<template>
  <div>
    <el-form :model="productForm" :rules="rules" ref="productRef" label-width="120px">
      <!-- 隐藏的id字段 -->
      <el-form-item v-show="false" prop="id">
        <el-input v-model="productForm.id"></el-input>
      </el-form-item>

      <!-- 其他表单字段 -->
      <el-row>
        <el-col :span="12">
          <el-form-item label="资金平台" prop="platformId">
            <el-select v-model="productForm.platformId" placeholder="请选择资金平台" style="width: 200px;">
              <el-option
                  v-for="item in platformList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="产品名称" prop="name">
            <el-input
                class="searchInput"
                v-model="productForm.name"
                :precision="2"
                :step="0.1"
                controls-position="right"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!-- 期数变化时生成还款计划 -->
          <el-form-item label="期数(月)" prop="duration">
            <el-input-number
                v-model="productForm.duration"
                :min="1"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <!-- 名称、利率、期数等字段 -->
          <el-form-item label="利率(%)" prop="rates">
            <el-input-number
                v-model="productForm.rates"
                :precision="2"
                :step="0.1"
                controls-position="right"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="罚息" prop="interestPenalty">
            <el-input-number
                v-model="productForm.interestPenalty"
                :min="0"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="GPS安装费" prop="gpsInstallFee">
            <el-input-number
                v-model="productForm.gpsInstallFee"
                :min="0"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!-- 一次性服务费 -->
          <el-form-item label="一次性服务费(%)" prop="onceServeFee" label-width="128px">
            <el-input-number
                v-model="productForm.onceServeFee"
                :precision="2"
                :step="0.1"
                controls-position="right"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="分区" prop="zone">
            <el-input-number
                v-model="productForm.zone"
                :min="0"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="产品描述">
        <el-input
            class="textarea"
            type="textarea"
            :rows="3"
            placeholder="请输入内容"
            v-model="productForm.describe">
        </el-input>
      </el-form-item>

      <el-form-item label="还款计划">
        <div class="responsive-scroll">
          <!-- 还款计划表格 -->
          <el-table class="tablebox" :data="productForm.productPlanList" border>
            <el-table-column label="期数" width="120">
              <template #default="{ row }">
                {{ row.period ? '第' + row.period + '期' : '待计算' }}
              </template>
            </el-table-column>
            <el-table-column label="月利率" width="150">
              <template #default="{ row }">
                <el-input type="number"
                          v-model="row.rates"
                          :min="0"
                          :precision="2"
                          :step="0.01"
                />
              </template>
            </el-table-column>
            <el-table-column label="服务费（元）" width="150">
              <template #default="{ row }">
                <el-input type="number"
                          v-model="row.serveFee"
                          :min="0"
                          :precision="2"
                />
              </template>
            </el-table-column>
            <el-table-column label="GPS费（元）" width="150">
              <template #default="{ row }">
                <el-input type="number"
                          v-model="row.gpsFee"
                          :min="0"
                          :precision="2"
                />
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>
      <!-- 表单操作按钮 -->
      <el-form-item>
        <el-button @click="resetForm('productRef')">重置</el-button>
        <el-button type="primary" @click="submitForm">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {saveProduct, getProductDetail} from "@/api/prod/product/product";
import {getPlatformList} from "@/api/prod/platform/platform";

export default {
  data() {
    return {
      productForm: {
        id: null,
        platformId: null,
        name: '',
        rates: 0,
        onceServeFee: 0,
        gpsInstallFee: 0,
        duration: 1,
        zone: 0,
        interestPenalty: 0,
        describe: '',
        productPlanList: [], // 表格显示数据
      },
      platformList: [],
      rules: {
        name: [{required: true, message: '请输入产品名称', trigger: 'blur'}],
        platformId: [{required: true, message: '请选择资金平台', trigger: 'change'}],
        rates: [
          {required: true, message: '请输入利率'},
          {type: 'number', min: 0, message: '利率不能为负'}
        ],
        onceServeFee: [
          {required: true, message: '请输入一次性服务费'},
          {type: 'number', min: 0, message: '一次性服务费不能为负'}
        ],
        gpsInstallFee: [
          {required: true, message: '请输入GPS安装费'},
          {type: 'number', min: 0, message: '一次性服务费不能为负'}
        ],
        duration: [
          {required: true, message: '请输入期数'},
          {type: 'number', min: 1, message: '期数至少1个月'}
        ],
        interestPenalty: [
          {required: true, message: '请输入罚息'},
          {type: 'number', min: 0, message: '罚息不能为负'}
        ]
      }
    };
  },
  mounted() {
    this.fetchPlatforms();
    if (this.$route.query && this.$route.query.id) {
      this.loadProductData();
    } else {
      this.generateRepaymentPlan();
    }
  },
  watch:{
    "productForm.duration":{
      handler(){
        this.generateRepaymentPlan();
      }
    }
  },
  methods: {
    // 获取平台列表
    async fetchPlatforms() {
      try {
        const data = await getPlatformList();
        this.platformList = data;
      } catch (error) {
        console.error('获取资金平台失败:', error);
      }
    },
    // 加载产品详情（编辑模式）
    async loadProductData() {
      try {
        const data = await getProductDetail({id: this.$route.query.id});
        Object.assign(this.productForm, data);
        console.info('加载产品详情（编辑模式:', this.productForm);
      } catch (error) {
        console.error('加载产品数据失败:', error);
        this.$message.error('加载数据失败');
      }
    },

    // 生成还款计划
    generateRepaymentPlan() {
      if(this.productForm.productPlanList && this.productForm.productPlanList.length && this.productForm.productPlanList.length >0){
        if(this.productForm.productPlanList.length - this.productForm.duration ===1 ){
          this.productForm.productPlanList.pop()
          return;
        }else if(this.productForm.productPlanList.length > this.productForm.duration){
          this.productForm.productPlanList = this.productForm.productPlanList.slice(0,this.productForm.duration)
          return;
        }
      }
      let from = Array.from({length: this.productForm.duration}, (_, i) => {
        const period = i + 1;
        return {
          period,
          rates: 0,
          serveFee: 0,
          gpsFee: 0
        };
      });
      const setlist = new Set(this.productForm.productPlanList.map(m => m.period));
      const newItems = from.filter(item => !setlist.has(item.period))
      this.productForm.productPlanList = [...this.productForm.productPlanList, ...newItems];
    },


    // 提交表单
    async submitForm() {
      try {
        await this.$refs.productRef.validate();
        await saveProduct(this.productForm);
        this.$message.success('保存成功');
        this.$router.back();
      } catch (error) {
        console.error('提交失败:', error);
        this.$message.error(error.response?.data?.message || '保存失败');
      }
    },

    // 重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.generateRepaymentPlan();
    }
  }
};
</script>

<style scoped>
.responsive-scroll {
  margin-top: 10px;

  .tablebox {
    width: 100%;
    max-height: 500px;
    overflow-y: auto;
    position: relative;
    border-bottom: 1px solid #fff !important;

    ::v-deep.el-table::before {
      display: none !important;
    }

    ::v-deep(.el-table__body-wrapper) {
      overflow-x: scroll !important;
    }
  }
}

.textarea {
  width: 50%;
}
</style>